module.exports = __webpack_public_path__ + "img/Mode_Selector_Joker.d10c3e6d.png";